import React, { useState } from "react";
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import Button from '../../Shared/UI/Button/components/Button';
import DeleteDocumentModal from './DeleteDocumentModal';

import styles from './Discourse.module.scss';

import {
  approveDocument,
  denyDocument,
  requestRevisionsForDocument,
  saveDocument,
  submitDocument,
  deleteDocument,
} from "../../DiscourseIndex/components/restApi";

const DiscoursePublishingWorkflowControls = ({
  authenticatedUser,
  contentEditable,
  setContentEditable,
  state,
  setState,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const showAdminButtons = authenticatedUser?.canEditAllDocuments;
  const showAuthorButtons = authenticatedUser?.canEditAllDocuments;
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
  const onResponse = response => setState(prevState => ({ ...prevState, ...response }));
  const onError = feedback => setState(prevState => ({ ...prevState, ...feedback }));

  const canDelete = state.documentManager &&
    state.documentManager.aasmState !== 'published' &&
    !state.documentManager.publishedAt;

  const handleDeleteClick = () => {
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = () => {
    deleteDocument({
      documentManagerId: state.documentManager.id,
      onResponse: (response) => {
        onResponse(response);
        window.location.href = '/discourse/published';
      },
      onError,
      body: {
        authenticityToken: authenticityToken,
      },
    });
    setDeleteModalOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
  };

  return (
    <div className={styles.workflowControlsSection}>
      <ActionRow>
        {showAdminButtons && (
          <Button
            variant="primary"
            onClick={() => {
              approveDocument({
                onResponse,
                onError,
                body: {
                  documentManagerId: state.documentManager.id,
                  authenticityToken: authenticityToken,
                },
              });
            }}
          >
            Approve
          </Button>
        )}
        {showAdminButtons && (
          <Button
            variant="secondary"
            onClick={() => {
              requestRevisionsForDocument({
                onResponse,
                onError,
                body: {
                  documentManagerId: state.documentManager.id,
                  authenticityToken: authenticityToken,
                },
              });
            }}
          >
            Request Revision
          </Button>
        )}
        {showAdminButtons && (
          <Button
            variant="destructive"
            onClick={() => {
              denyDocument({
                onResponse,
                onError,
                body: {
                  documentManagerId: state.documentManager.id,
                  authenticityToken: authenticityToken,
                },
              });
            }}
          >
            Deny
          </Button>
        )}
      </ActionRow>
      <ActionRow>
        {showAuthorButtons && !contentEditable && (
          <Button
            variant="primary"
            onClick={() => {
              submitDocument({
                onResponse,
                onError,
                body: {
                  documentManagerId: state.documentManager.id,
                  authenticityToken: authenticityToken,
                },
              });
            }}
          >
            Submit
          </Button>
        )}
        {showAuthorButtons && contentEditable && (
          <Button
            variant="primary"
            onClick={() => {
              setContentEditable(false);
              saveDocument({
                onResponse,
                onError,
                body: {
                  ...state.documentManager.getCurrentDocument().asJSON(),
                  authenticityToken: authenticityToken,
                },
              });
            }}
          >
            Save
          </Button>
        )}
        {showAuthorButtons && !contentEditable && (
          <Button
            variant="secondary"
            onClick={() => {
              setContentEditable(true);
            }}
          >
            Edit
          </Button>
        )}
        {showAuthorButtons && contentEditable && (
          <Button
            variant="secondary"
            onClick={() => {
              setContentEditable(false);
            }}
          >
            Cancel Edit
          </Button>
        )}
        {showAdminButtons && canDelete && (
          <Button
            variant="destructive"
            onClick={handleDeleteClick}
          >
            Delete
          </Button>
        )}
      </ActionRow>
      <DeleteDocumentModal
        isOpen={deleteModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default DiscoursePublishingWorkflowControls;